import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.finally.js";
import "regenerator-runtime/runtime.js";
export default function (_ref) {
  var app = _ref.app;
  app.i18n.onLanguageSwitched = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return app.store.dispatch('storeDispatchFunc');

          case 2:
            app.apolloProvider.defaultClient.cache.reset();

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}
;